import React, {
  InputHTMLAttributes,
  useEffect,
  useRef,
  useState,
  useCallback,
} from 'react';
import { Flex } from '@chakra-ui/react';
import { IconBaseProps } from 'react-icons';
import { useField } from '@unform/core';
import { FiAlertCircle } from 'react-icons/fi';

import { Container, Error } from './styles';

interface OptionsDATA {
  value: number;
  label: string;
}
interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  icon?: React.ComponentType<IconBaseProps>;
  containerStyle?: {};
  options: OptionsDATA[];
}

const ComboBox: React.FC<InputProps> = ({
  name,
  icon: Icon,
  options,
  containerStyle,
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
	const iconRef = useRef<any>(null);

  const [isFocused, setIsFocused] = useState(false);
  const [isField, setIsField] = useState(false);
  const { fieldName, defaultValue, error, registerField } = useField(name);

  const handleInputFocus = useCallback(() => {
    setIsFocused(true);
  }, []);

  const handleInputBlur = useCallback(() => {
    setIsFocused(false);
    setIsField(!!inputRef.current?.value);
  }, []);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  return (
    <Container
      isErrored={!!error}
      isField={isField}
      isFocused={isFocused}
      style={containerStyle}
    >
      {Icon && <Icon />}

      <input
        onFocus={handleInputFocus}
        onBlur={handleInputBlur}
        defaultValue={defaultValue}
        ref={inputRef}
        {...rest}
        list="opts"
      />
      <datalist id="opts">
        {options.map(item => (
          <option
            key={item.value}
            value={`${item.value} - ${item.label}`}
            placeholder={item.label}
          />
        ))}
      </datalist>

      {error && (
				<Error title={error}>
					<Flex mr={-4} ref={iconRef}>
						<FiAlertCircle color="#c53030" size={20} />
					</Flex>
				</Error>
      )}
    </Container>
  );
};

export default ComboBox;
